import React , { Component }from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
import './assets/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/rfs.css';
import * as myConstClass from './constant.js';
import { Editor} from 'react-draft-wysiwyg';
import { EditorState,convertToRaw,convertFromRaw  } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {stateToHTML} from 'draft-js-export-html'; 
import Header from './Header.js';
import Footer from './Footer.js';
import $ from 'jquery';
import SimpleReactValidator from 'simple-react-validator';

// Translation Higher Order Component
import {
    setTranslations,
    setDefaultLanguage,
    setLanguageCookie,
    setLanguage,getLanguage,
    translate,
  } from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import PropTypes from 'prop-types';
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Col,
    Form,
    FormGroup,
    Input,  
    Label,
    Row,
    
  } from 'reactstrap';
class Verifyotp extends Component {
    constructor(props) {
      super(props);
      this.product_id=0;
      this.state = {
        isLoading: false,
        flag:0,
        guestinfo: {
            user_id: '',
            otp_email:'',
            otp: ''
          },
          otpDetails:[],
      }
      this.handleSubmit = this.handleSubmit.bind(this);
      this.resendOTP = this.resendOTP.bind(this);
      this.resendEmailOTP = this.resendEmailOTP.bind(this);
      this.validator = new SimpleReactValidator();
  }

  resendOTP() {
    const otp_email = localStorage.getItem('otp_email');
    
    fetch(myConstClass.AUTH_API + '/resend-otp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: otp_email
      })
    })
    .then(response => response.json())
    .then(response => {
      const { status, message } = response;
      if(status === 'true') {
        toast(message, {containerId: 'B', type: toast.TYPE.SUCCESS});
      } else {
        toast(message, {containerId: 'B', type: toast.TYPE.ERROR});
      }
    })
    .catch((error) => {
      console.error('Error resending OTP:', error);
      toast('Failed to resend OTP. Please try again.', {containerId: 'B', type: toast.TYPE.ERROR});
    });
  }

  // Using resendOTP for both since we only need email verification now
  resendEmailOTP() {
    this.resendOTP();
  }

  componentDidMount() {
    var otp_email = localStorage.getItem('otp_email');
    console.log('Component mounted. Email from localStorage:', otp_email);
    console.log('All localStorage keys:', Object.keys(localStorage));
    
    if(otp_email !== '' && otp_email !== undefined && otp_email !== null){
     // alert(otp_email);
      this.setState(prevState => ({
        guestinfo: {
          ...prevState.guestinfo,
          otp_email: otp_email
        }
      }));
    } else {
      console.error('No email found in localStorage, redirecting to home');
      setTimeout(() => this.props.history.push(''), 10);
    }
    var message =  localStorage.getItem('success');
    if(message !== '' && message !== null){
      toast(''+message, {containerId: 'B',type: toast.TYPE.SUCCESS});

      localStorage.removeItem('success');
    }
    var error =  localStorage.getItem('error');
    if(error !== '' && error !== null){
      toast(''+error, {containerId: 'B',type: toast.TYPE.ERROR});
      localStorage.removeItem('error');
    }
//       fetch(myConstClass.BASE_URL+'product/getAvailProdTypes')
//       .then(response => response.json())
//       .then(response =>this.setState({types: response}))
//       .catch(err => console.log(err))
          
      
//       const answer_array = this.props.location.pathname.split('/');
//        // alert(answer_array);
//     if(answer_array['2']){
     
//   fetch(myConstClass.BASE_URL+'product/getProductInfo/'+answer_array['2']+'/'+getLanguage())
//   .then(response => response.json())
//   .then(response =>this.setState({guestinfo: response}))  
//   .catch(err => console.log(err))

//   fetch(myConstClass.BASE_URL+'product/getRelatedProducts/'+answer_array['2'])
//       .then(response => response.json())
//       .then(response =>this.setState({posts: response}))
//       .catch(err => console.log(err))

//     }  
  }

  componentDidUpdate(prevProps) {
      // const answer_array = this.props.location.pathname.split('/');
      // const { flag} = this.state  
      // alert(answer_array);
//    if(answer_array['2'] && getLanguage()=='ma' && flag==0){
//     this.setState({flag:1})
//  fetch(myConstClass.BASE_URL+'product/getProductInfo/'+answer_array['2']+'/'+getLanguage())
//  .then(response => response.json())
//  .then(response =>this.setState({guestinfo: response}))  
//  .catch(err => console.log(err))
//    }

//    if(answer_array['2'] && getLanguage()=='en' && (flag==1)){
//     this.setState({flag:0})
//  fetch(myConstClass.BASE_URL+'product/getProductInfo/'+answer_array['2']+'/'+getLanguage())
//  .then(response => response.json())
//  .then(response =>this.setState({guestinfo: response}))  
//  .catch(err => console.log(err))
//    }
  }

  handleSubmit(e) {
    $('#btn_click').css('display','none');
    $('#loader').css('display','inline');
    e.preventDefault();
    
    var otp_email = localStorage.getItem('otp_email');
    
    // Debug logging
    console.log('OTP Email from localStorage:', otp_email);
    console.log('OTP from state:', this.state.guestinfo.otp);
    
    // Basic validation check
    if (!this.state.guestinfo.otp || this.state.guestinfo.otp.trim() === '') {
        $('#btn_click').css('display','inline');
        $('#loader').css('display','none');
        toast('Please enter the OTP.', {containerId: 'B',type: toast.TYPE.ERROR});
        return;
    }
    
  if (!otp_email) {
    $('#btn_click').css('display','inline');
    $('#loader').css('display','none');
    toast('Email not found. Please try registering again.', {containerId: 'B',type: toast.TYPE.ERROR});
    // store current path and redirect to signin
    localStorage.setItem('redirect_after_login', window.location.pathname);
    this.props.history.push('/signin');
    return;
  }
    
    if (this.validator.allValid() || true) { // Temporarily bypass validator
    const requestData = {
      email: otp_email,
      otp: this.state.guestinfo.otp
    };
    
    console.log('Sending OTP verification request:', requestData);
    
    fetch(myConstClass.AUTH_API + '/verify-otp', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestData)
}).then(response => response.json())
.then(response => {
    console.log('OTP verification response:', response);
    this.setState({otpDetails: response});
    var status = response.status;
    var message = response.message;
    if(status === 'true') {
        // Handle both simple response and detailed user response
        const userData = response.user_details || response;
        const user_id = userData.user_id || response.user_id;
        const email = userData.email || response.email;
        const first_name = userData.first_name || userData.firstName || '';
        const last_name = userData.last_name || userData.lastName || '';
        const middle_name = userData.middle_name || userData.middleName || '';
        const profile_picture = userData.profile_picture || userData.profilePicture || '';
        const is_verify_sadhak_no = userData.is_verify_sadhak_no || userData.isVerifySadhakNo || 0;
        
        // Store all user data
        localStorage.setItem('user_id', user_id);
        localStorage.setItem('email', email);
        localStorage.setItem('first_name', first_name);
        localStorage.setItem('last_name', last_name);
        localStorage.setItem('middle_name', middle_name);
        localStorage.setItem('profile_picture', profile_picture);
        localStorage.setItem('is_verify_sadhak_no', is_verify_sadhak_no);
        
        toast(message, {containerId: 'B',type: toast.TYPE.SUCCESS});
        
        // Clear all user data and redirect to login page
        setTimeout(() => {
            // IMPORTANT: Preserve guest cart before clearing localStorage
            const guestProducts = localStorage.getItem('guest_cart_products');
            const guestMagazines = localStorage.getItem('guest_cart_magazines');
            const guestEvents = localStorage.getItem('guest_cart_events');
            const redirectPath = localStorage.getItem('redirect_after_login');
            
            // Clear all localStorage
            localStorage.clear();
            
            // Restore guest cart items
            if (guestProducts) localStorage.setItem('guest_cart_products', guestProducts);
            if (guestMagazines) localStorage.setItem('guest_cart_magazines', guestMagazines);
            if (guestEvents) localStorage.setItem('guest_cart_events', guestEvents);
            if (redirectPath) localStorage.setItem('redirect_after_login', redirectPath);
            
            localStorage.setItem('success', 'Registration completed successfully! Please login with your credentials.');
            this.props.history.push('/signin');
        }, 1000);
    } else {
        console.error('OTP verification failed:', message);
        $('#btn_click').css('display','inline');
        $('#loader').css('display','none');
        toast(message, {containerId: 'B',type: toast.TYPE.ERROR});
    } 
})
.catch((error) => {
    console.error('OTP verification error:', error);
    $('#btn_click').css('display','inline');
    $('#loader').css('display','none');
    toast('An error occurred during verification. Please try again.', {containerId: 'B',type: toast.TYPE.ERROR});
});
    }else{
      $('#btn_click').css('display','inline');
      $('#loader').css('display','none');
        //alert('here');
        this.validator.showMessages();
        console.log('validations'+this.validator.showMessages());
        e.preventDefault();
        toast('Please fill all required fields.', {containerId: 'B',type: toast.TYPE.ERROR})
       // toast('Please fill all required fields.', {containerId: 'B',type: toast.TYPE.ERROR})
    }
  }

  render() {
    const { guestinfo } = this.state  
    const { t } = this.props;
  return (
    <div className="App">
         <div>
        {/* <button onClick={this.notify}>Notify !</button> */}
          <ToastContainer />
        </div>
    <Header />
    <div class="container-fluid">
   
        <div class="row">
            <div class="col-lg-12 mt-3">
                <div class="row mt-5 m-xl-0 mt-lg-0 mt-md-4 mt-sm-5">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb bg-white mb-0">
                            <li class="breadcrumb-item"><Link   to="/">{t('home.home')}</Link></li>
                            <li class="breadcrumb-item active" aria-current="page">{t('home.Verify OTP')}</li>
                        </ol>
                    </nav>
                </div>
                <div class="row">
                    <div class="col">
                        <h4>{t('home.Verify OTP')}</h4>
                        <p>{t('home.Please fill in the details below')}: <span class="color-red">* {t('home.Mandatory Fields')}</span></p>
                    </div>
                </div>
            </div>

            <div class="col col-lg-10 mt-3">
                {/* <form> */}
                <Form action="" id="pform" onSubmit={this.handleSubmit}  method="post" encType="multipart/form-data" className="form-horizontal">
                    
                    <div class="row">
                        <div class="form-group col col-md-4">
                            <label class="color-black font-weight-bolder">{t('home.Email OTP')}<span class="color-red">*</span></label>
                            <input 
                                value={guestinfo.otp || ''} 
                                onChange={e => {
                                    console.log('OTP input changed:', e.target.value);
                                    this.setState({ guestinfo: {...guestinfo, otp:e.target.value}});
                                }} 
                                onBlur={() => this.validator.showMessageFor('otp')} 
                                type="text" 
                                id="otp" 
                                name="otp" 
                                className="form-control" 
                                placeholder={t('home.Enter Email OTP')} 
                                maxLength="6"
                            />
                            {this.validator.message('otp', this.state.guestinfo.otp, 'required')}
                        </div>
                        <div class="form-group col col-md-4">
                        {this.state.isLoading ?
                          <img id="loader" name="loader" src={myConstClass.IMAGE_URL+'loader.gif'} className="img-fluid" style={{ position:'absolute', marginTop: '10%' }} alt="Loading..." />
                          :
                          <button 
                            onClick={this.resendEmailOTP} 
                            style={{textDecoration:'underline',cursor:'pointer',color:'blue',marginTop:'12%',position:'absolute',border:'none',background:'none',padding:0}}
                            disabled={this.state.isLoading}
                          >
                            {t('home.Resend OTP')}
                          </button>}
                        </div>
                    </div>
                    

                    
                    
                    <div class="row">
                        <div class="form-group col col-md-4">
                            <button id="btn_click" name="btn_click" className="btn btn-brown">{t('home.Verify')}</button>
                            <img style={{display:'none'}} id="loader" name="loader" src={myConstClass.IMAGE_URL+'loader.gif'} className="img-fluid" alt="Loading..." />
                        </div>
                    </div>
                    </Form>

            </div>
        </div>
    </div>
    <Footer />
    </div>
  );
}
}
Verifyotp.propTypes = {
    t: PropTypes.func.isRequired,
  };
export default translate(Verifyotp);
